import { render } from "./EquipmentDetailView.vue?vue&type=template&id=06c4409e&scoped=true"
import script from "./EquipmentDetailView.vue?vue&type=script&lang=js"
export * from "./EquipmentDetailView.vue?vue&type=script&lang=js"

import "./EquipmentDetailView.vue?vue&type=style&index=0&id=06c4409e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c4409e"]])

export default __exports__